import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import Select from 'react-dropdown-select';
import countries from '../Register/registerCountriesData';
import states from '../Register/registerStatesData';

import InputField from 'components/LoginForm/Input';

const RegisterIndustryVisitor = (props) => (
  <div className="Register">
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder="Email"
      icon="at"
      focus
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_password"
      fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
      icon="key"
      line
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_passwordConfirm"
      fieldPlaceholder={i18n.translate('loginScreen.fields.passwordConfirm')}
      icon="key"
      line
    />

    <div className="step">Step 3: Complete your profile.</div>
    <h1 style={{ color: props.individualShowData ? props.individualShowData.primary_color : '' }}>
      <b>Tell Us About Yourself</b>
    </h1>
    <hr
      className="short"
      style={{
        backgroundColor: props.individualShowData ? props.individualShowData.primary_color : '',
      }}
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_agency_name"
      fieldPlaceholder="Company Name"
      icon="home"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.firstName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.lastName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_title"
      fieldPlaceholder="Title"
      icon="user"
    />

    <select id="reg_country" name="reg_country" onChange={props.change} value={props.reg_country}>
      <option value="" disabled selected>
        {i18n.translate('loginScreen.fields.select')}
      </option>
      {countries.map((c, index) => {
        const key = index;
        return (
          <option key={key} value={c.code}>
            {c.name}
          </option>
        );
      })}
    </select>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_city"
      fieldPlaceholder={i18n.translate('loginScreen.fields.city')}
      icon="user"
    />

    {props.country !== 'US' && (
      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_state"
        fieldPlaceholder={i18n.translate('loginScreen.fields.stateProvince')}
        icon="map"
        line
        defaultVal={props.reg_state}
        required
      />
    )}

    {props.country === 'US' && (
      <React.Fragment>
        <p htmlFor="reg_state" className="reg_state">
          {i18n.translate('loginScreen.fields.stateProvince')} *
        </p>
        <select id="reg_state" name="reg_state" onChange={props.change} value={props.state}>
          <option value="" disabled selected>
            {i18n.translate('loginScreen.fields.select')}
          </option>
          {states.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.value}>
                {c.label}
              </option>
            );
          })}
        </select>
      </React.Fragment>
    )}

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="text"
      fieldName="reg_zip_code"
      fieldPlaceholder={i18n.translate('loginScreen.fields.zipCode')}
      icon="map"
    />

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="tel"
      fieldName="reg_phone_number"
      fieldPlaceholder={i18n.translate('loginScreen.fields.phone')}
      icon="phone"
    />

    <h1 style={{ color: props.individualShowData ? props.individualShowData.primary_color : '' }}>
      <b>Describe Your Business</b>
    </h1>
    <hr
      className="short"
      style={{
        backgroundColor: props.individualShowData ? props.individualShowData.primary_color : '',
      }}
    />

    <p htmlFor="reg_agency_business" className="spacer">
      What best describes your company’s business?
    </p>
    <select id="reg_agency_business" name="reg_agency_business" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="AAA Travel Agent"> AAA Travel Agent </option>
      <option value="AAA Employee"> AAA Employee </option>
      <option value="Accommodation"> Accommodation </option>
      <option value="Association"> Association </option>
      <option value="Attraction">Attraction </option>
      <option value="Aviation"> Aviation </option>
      <option value="Corporate Travel"> Corporate Travel </option>
      <option value="Cruise"> Cruise </option>
      <option value="Destination Management Company"> Destination Management Company </option>
      <option value="Financial / Services"> Financial / Services </option>
      <option value="Government Agency"> Government Agency </option>
      <option value="Ground Transportation"> Ground Transportation </option>
      <option value="Insurance"> Insurance </option>
      <option value="Media"> Media </option>
      <option value="Non-Profit">Non-Profit </option>
      <option value="Other">Other </option>
      <option value="Retail"> Retail </option>
      <option value="Technology"> Technology </option>
      <option value="Tourism Board"> Tourism Board </option>
      <option value="Tour Operator"> Tour Operator </option>
      <option value="Tours & Activities"> Tours & Activities </option>
      <option value="Travel Agency"> Travel Agency </option>
    </select>

    <p htmlFor="" className="spacer">
      What regions does your business serve? (Click all that apply)
    </p>

    <Select
      multi
      labelField="value"
      valueField="value"
      options={[
        { value: 'Africa & Middle East' },
        { value: 'Asia & South Pacific' },
        { value: 'Caribbean' },
        { value: 'Central & South America' },
        { value: 'Europe' },
        { value: 'Hawaii' },
        { value: 'Mexico' },
        { value: 'USA & Canada' },
      ]}
      values={
        props.userInput.reg_custom_1
          ? props.userInput.reg_custom_1.split(', ').map((value) => ({
              value,
            }))
          : []
      } // autofill
      onChange={(values) => {
        console.log('values', values);

        props.change({
          target: { name: 'reg_custom_1', value: values.map(({ value }) => value).join(', ') },
        });
      }}
    />

    <InputField
      change={props.change}
      fieldLabel="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      fieldName="marketing_opt_in"
      fieldType="checkbox"
      icon="clipboard-check"
      userSelect={false}
      line={false}
      title="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      defaultSelected
    />

    <div className="login__form--buttons">
      <button
        type="submit"
        onClick={props.submit}
        className="Email__input--button"
        style={{
          backgroundColor: props.individualShowData ? props.individualShowData.primary_color : '',
        }}
      >
        {props.loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        ) : (
          i18n.translate('loginScreen.register')
        )}
      </button>
    </div>
  </div>
);

export default RegisterIndustryVisitor;

RegisterIndustryVisitor.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

RegisterIndustryVisitor.defaultProps = {
  defaultVal: '',
};
